import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button";

export default function ActionButtonsNew() {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div>
      <Button
        color="bg-red-600 hover:bg-red-500"
        onClick={() => {
          navigate("/main/invoice/new/mail", { state: id });
        }}
        text="Send to Wait"
      />
    </div>
  );
}
